import { useMemo } from "react";
import { Autocomplete, TextField } from "@mui/material";

import { IOptionSelection } from "models/GlobalOptions/IGlobalOptionsSelections";
import useTranslations from "helpers/hooks/useTranslations";
import useGlobalOptions from "components/GlobalOptions/useGlobalOptions";

const OldOptionSelection: React.FC<any> = () => {

    const tm = useTranslations();
    const { selections, onOldOptionChange } = useGlobalOptions();

    const selectedOldOption = useMemo(() => {
        let selection = selections.oldOptionSelections?.find((q) => q.value === selections.selectedOldOption);

        if (!selection) {
            selection = { description: "", value: "" };
        }
        return selection;

    }, [selections]);


    return <>
        <Autocomplete
            autoComplete
            disableClearable
            autoSelect
            autoHighlight
            selectOnFocus
            handleHomeEndKeys
            options={selections.oldOptionSelections}
            getOptionLabel={(s: IOptionSelection) => s.description}
            renderInput={(params) => (
                <TextField
                    {...params}
                    size="small"
                    label={tm.Get("Old Option")}
                    InputProps={{
                        ...params.InputProps,
                    }}
                />
            )}
            onChange={(_, value) => onOldOptionChange(value.value)}
            value={selectedOldOption}
        />
    </>;
};


export default OldOptionSelection;
